<template>
<!-- v-model="dateTime" -->
  <el-date-picker
    :value="value"
    @input="handleChange"
    v-bind="{
      ...defaultAttrs,
      ...attrs,
    }"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'search-date',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    attrs: {
      type: Object,
    },
    isSearch: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      defaultAttrs: {
        type: 'datetimerange',
        startPlaceholder: "创建开始日期",
        endPlaceholder: "创建结束日期",
        rangeSeparator: '-',
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        clearable: true,
      }
    }
  },
  methods: {
    handleChange(v) {
      if(v === null) {
        this.$emit('change', [])
        this.isSearch && this.$emit('search')
        return 
      }
      this.$emit('change', v)
      this.isSearch && this.$emit('search')
      return 
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
